import store from "../../store";
import Api from "../../api";
import config from "../../config";

const state = () => ({
    rewards: [],
    tiers: [],
    coupons: [],
    banners: [],
    balance: 0,
    termsAccepted: false,
    loading: false,
    transactions: [],
});

const actions = {
    loadData({ commit, rootState }) {
        if (config.isPreview) {
            return Promise.resolve();
        }

        const isLogged = !!(rootState.client && rootState.client.id && rootState.token);
        const request = isLogged
            ? Api.get("client/dashboard")
            : Api.get("place/" + window.PLACE_SLUG + "/benefits/dashboard");

        commit("setLoading", true);

        return request
            .then((response) => {
                commit("setData", response.data);
            })
            .catch(() => {})
            .then(() => {
                commit("setLoading", false);
            });
    },
};

const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },
    setData(state, data) {
        state.rewards = data.rewards || [];
        state.tiers = data.tiers || [];
        state.coupons = data.coupons || [];
        state.banners = data.banners || [];
        state.balance = data.balance || 0;
        state.termsAccepted = !!data.termsAccepted;
    },
    setTermsAccepted(state, accepted) {
        state.termsAccepted = accepted;
    },
    setBalance(state, balance) {
        state.balance = Math.max(0, balance);
    },
    setTransactions(state, transactions) {
        state.transactions = transactions || [];
    },
    addTransaction(state, transaction) {
        state.transactions = [transaction, ...state.transactions];
    },
};

const getters = {
    progress(state) {
        const redeemable = state.rewards.filter((reward) => !["locked", "blurred"].includes(reward.access));
        if (!redeemable.length) {
            return 0;
        }

        const target = redeemable[redeemable.length - 1].points;
        if (!target) {
            return 0;
        }

        return Math.min(Math.floor((state.balance / target) * 100), 100);
    },
};

store.registerModule("dashboard", {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
});

export default store;
